import { AbstractedUpsellCategory } from '@vfde-sails/glados-v2';
import { getQueryParam } from '@vfde-sails/utils';
import { CATEGORY_URL_SEPARATOR } from '../constants';

/**
 * Get all filters from URL
 */
export const getCategoriesFromUrl = (): AbstractedUpsellCategory[] => {
    const categories = getQueryParam('categories') as string | undefined;

    if (categories) {
        const sanitizedCategories = categories.replace(/[^\w,|*]/gi, '');

        return sanitizedCategories.split(CATEGORY_URL_SEPARATOR).map((value: string): AbstractedUpsellCategory => ({
            value,
        } as AbstractedUpsellCategory));
    }

    return [];
};
